angular.module('routes.reports.ReportsPayloadResolver', [
  'stack'
])

/**
 * The ReportsPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class ReportsPayloadResolver
 * @constructor
 * @module routes.reports.ReportsPayloadResolver
 */
.factory('ReportsPayloadResolver', [
  '$q',
  '$rootScope',
  'GLOBAL',
  'ModelsService',
  function ($q, $rootScope, GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      var promise;

      if (params.reportId) {
        promise = ModelsService
          .get('reports', GLOBAL.apiPath + '/reports', { id: params.reportId })
          .then(function (reportsResponse) {
            var queue;
            var result;
            $rootScope.report = reportsResponse;

            // case
            ModelsService.get('cases', GLOBAL.apiPath + '/cases', { id: reportsResponse.content.simulation.id })
            .then(function (currentcase) {
              $rootScope.report.content.case = currentcase;
              return currentcase;
            })
            .catch(function () {
              return;
            });

            // events
            if (params.reportId) {
              queue = _.map(reportsResponse.content.events, function (e) {
                return ModelsService.get('events', GLOBAL.apiPath + '/events', { id: e.id });
              });

              result = $q.all(queue);
            } else {
              result = {};
            }
            return result;
          })
          .then(function (eventsResponse) {
            if (params.reportId) {
              $rootScope.report.content.events = eventsResponse;
            }
            return {};
          });
      }
      return promise;
    };
  }
]);
